import {
  AddedRow,
  DeletedRow,
  InitialRow,
} from '../../../../applications/ports/versionReportVersionRepository'
import {
  VersionReportPageConfig,
  VersionReportVersionPageRowEntity,
} from '../../../../domain/entity/version-report/VersionReportVersionEntity'

// 表示対象 targetUuid 配列。OVERVIEW は rows を持たないため常に空。
export const getNewTargetUuids = (
  config: VersionReportPageConfig
): string[] => {
  if (config.type === 'PROGRESS_OVERVIEW') return []
  return config.tableRows
}

export const buildInitialRows = (
  config: VersionReportPageConfig
): InitialRow[] =>
  getNewTargetUuids(config).map((targetUuid, displayOrder) => ({
    targetUuid,
    displayOrder,
  }))

export const buildRowDiff = (
  config: VersionReportPageConfig,
  originalRows: VersionReportVersionPageRowEntity[]
): { addedRows: AddedRow[]; deletedRows: DeletedRow[] } => {
  const newTargetUuids = getNewTargetUuids(config)
  const originalTargetUuids = new Set(originalRows.map(r => r.targetUuid))
  const newTargetUuidsSet = new Set(newTargetUuids)

  const maxOrder = Math.max(-1, ...originalRows.map(r => r.displayOrder))
  const addedRows: AddedRow[] = newTargetUuids
    .filter(uuid => !originalTargetUuids.has(uuid))
    .map((uuid, i) => ({ targetUuid: uuid, displayOrder: maxOrder + 1 + i }))

  const deletedRows: DeletedRow[] = originalRows
    .filter(r => !newTargetUuidsSet.has(r.targetUuid))
    .map(r => ({ rowUuid: r.uuid, lockVersion: r.lockVersion }))

  return { addedRows, deletedRows }
}
